import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { useI18n, pick } from "@/lib/i18n";
import { useContent } from "@/lib/content";

export default function Countries() {
  const { lang } = useI18n();
  const { content } = useContent();
  const c = content?.countries;
  if (!c) return null;
  const header = pick(c, lang, c.ru);
  const items = c.items || [];
  return (
    <section id="countries" className="py-16 sm:py-20 lg:py-32 bg-muted/30 border-y border-border/40" data-testid="countries-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10 sm:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-semibold mb-4">
            {lang === "ru" ? "Направления" : "Destinations"}
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-5xl font-semibold tracking-tight">{header.title}</h2>
          <p className="mt-4 text-base text-muted-foreground">{header.subtitle}</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {items.map((it, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative overflow-hidden rounded-3xl border border-border bg-card hover:-translate-y-1.5 transition-transform duration-300 will-change-transform"
              data-testid={`country-${i}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={it.image}
                  alt=""
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-card via-card/20 to-transparent" />
                <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background/80 backdrop-blur text-xs font-medium">
                  <MapPin className="size-3" />
                  {lang === "ru" ? it.ru_name : it.en_name}
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-muted-foreground mb-3">
                  {lang === "ru" ? it.ru_jobs : it.en_jobs}
                </p>
                <div className="font-heading text-lg font-bold">{it.salary}</div>
                <div className="text-xs text-muted-foreground uppercase tracking-wider">
                  {lang === "ru" ? "в месяц" : "per month"}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
